import Lenis from 'lenis';

export function initScroll() {
    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
    });

    let rafId: number;
    let isRunning = true;

    function raf(time: number) {
        if (!isRunning) return;
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
    }

    rafId = requestAnimationFrame(raf);

    // 页面隐藏时暂停
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            isRunning = false;
            cancelAnimationFrame(rafId);
        } else {
            isRunning = true;
            rafId = requestAnimationFrame(raf);
        }
    });

    return lenis;
}